let categoriesSwiper = document.querySelector("[swiper='categories']");

if (categoriesSwiper) {
  const swiperElement = categoriesSwiper.querySelector(".swiper");

  const prevButton = categoriesSwiper.querySelector("[swiper='prev']");
  const nextButton = categoriesSwiper.querySelector("[swiper='next']");

  var swiper = new Swiper(swiperElement, {
    speed: 300,
    slidesPerView: "auto",
    spaceBetween: 12,
    loop: false,
    centeredSlides: false,
    mousewheel: { forceToAxis: true },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
      disabledClass: "hide",
    },
    breakpoints: {
      480: { slidesPerView: "auto", spaceBetween: 12, slidesPerGroup: 1 },
      768: { slidesPerView: "auto", spaceBetween: 12, slidesPerGroup: 1 },
      992: {
        slidesPerView: 5,
        spaceBetween: 12,
        slidesPerGroup: 1,
      },
    },
  });
}
